import { Injectable } from '@angular/core'
import * as _ from 'lodash'
@Injectable()
export class JqxGridVirtualPaging {
    public ready = (): any => {
        return {
            filterstringcomparisonoperators: [
                'equal',
                'not equal',
                'contains',
                'does not contain',
                'starts with',
                'ends with',
                'empty',
                'not empty',
                'null',
                'not null'
            ],
            // filter numeric comparison operators.
            filternumericcomparisonoperators: ['less than or equal', 'equal', 'greater than or equal'],
            // filter date comparison operators.
            filterdatecomparisonoperators: ['less than or equal', 'equal', 'greater than or equal'],
            // filter bool comparison operators.
            filterbooleancomparisonoperators: ['equal', 'not equal']
        }
    }
    public updatefilterconditions = (type: string): string[] | undefined => {
        let stringcomparisonoperators = [
            'EQUAL',
            'NOT_EQUAL',
            'CONTAINS',
            'DOES_NOT_CONTAINS',
            'STARTS_WITH',
            'ENDS_WITH',
            'EMPTY',
            'NOT_EMPTY',
            'NULL',
            'NOT_NULL'
        ]
        let numericcomparisonoperators = ['LESS_THAN_OR_EQUAL', 'EQUAL', 'GREATER_THAN_OR_EQUAL']
        let datecomparisonoperators = ['LESS_THAN_OR_EQUAL', 'EQUAL', 'GREATER_THAN_OR_EQUAL']
        let booleancomparisonoperators = ['EQUAL', 'NOT_EQUAL']
        switch (type) {
            case 'stringfilter':
                return stringcomparisonoperators
            case 'numericfilter':
                return numericcomparisonoperators
            case 'datefilter':
                return datecomparisonoperators
            case 'booleanfilter':
                return booleancomparisonoperators
        }
    }

    //public updatefilterconditions(type: string): string[] {
    //        let stringcomparisonoperators = ['EQUAL', 'NOT_EQUAL'];
    //        let numericcomparisonoperators = ['LESS_THAN_OR_EQUAL', 'EQUAL', 'GREATER_THAN_OR_EQUAL'];
    //        let datecomparisonoperators = ['LESS_THAN_OR_EQUAL', 'EQUAL', 'GREATER_THAN_OR_EQUAL'];
    //        let booleancomparisonoperators = ['EQUAL', 'NOT_EQUAL'];
    //        switch(type) {
    //        case 'stringfilter':
    //        return stringcomparisonoperators;
    //        case 'numericfilter':
    //        return numericcomparisonoperators;
    //        case 'datefilter':
    //        return datecomparisonoperators;
    //        case 'booleanfilter':
    //        return booleancomparisonoperators;
    //}

    onFilter(event: any, filterinfo: any): string {
        // let filterinfo = this.summaryGrid.getfilterinformation()
        let criteria = ''
        for (let i = 0; i < filterinfo.length; i++) {
            let field = filterinfo[i].filtercolumn
            let filters = filterinfo[i].filter.getfilters()
            let operator = filters[0].operator === 0 ? ' AND ' : ' OR '
            criteria += criteria === '' ? '(' : ' AND ('
            let subCriteria = ''
            for (let filter of filters) {
                if (subCriteria !== '') {
                    subCriteria += operator
                }
                if (filter.condition === 'LESS_THAN_OR_EQUAL') {
                    if (filter.type === 'numericfilter') {
                        subCriteria += `${field} <= ${filter.value}`
                    } else if (filter.type === 'datefilter') {
                        subCriteria += `${field} <= '${filter.value}'`
                    }
                } else if (filter.condition === 'GREATER_THAN_OR_EQUAL') {
                    if (filter.type === 'numericfilter') {
                        subCriteria += `${field} >= ${filter.value}`
                    } else if (filter.type === 'datefilter') {
                        subCriteria += `${field} >= '${filter.value}'`
                    }
                } else if (filter.condition === 'EQUAL') {
                    subCriteria += `${field} = '${filter.value}'`
                } else if (filter.condition === 'NOT_EQUAL') {
                    subCriteria += `${field} != '${filter.value}'`
                } else if (filter.condition === 'EMPTY') {
                    subCriteria += `${field} = ''`
                } else if (filter.condition === 'NOT_EMPTY') {
                    subCriteria += `${field} != ''`
                } else if (filter.condition === 'CONTAINS') {
                    subCriteria += `${field} LIKE  '%${filter.value}%'`
                } else if (filter.condition === 'DOES_NOT_CONTAINS') {
                    subCriteria += `${field} NOT LIKE  '%${filter.value}%'`
                } else if (filter.condition === 'NULL') {
                    subCriteria += `${field} IS NULL`
                } else if (filter.condition === 'NOT_NULL') {
                    subCriteria += `${field} IS NOT NULL`
                } else if (filter.condition === 'ENDS_WITH') {
                    subCriteria += `${field} LIKE  '%${filter.value}'`
                } else if (filter.condition === 'STARTS_WITH') {
                    subCriteria += `${field} LIKE  '${filter.value}%'`
                }
            }
            criteria += subCriteria + ')'
        }
        return criteria
        //    this.myClientsCriteria.FilterCriteria = criteria
        //    this.populateGrid()
    }

    onSort(event: any): string {
        let sortinformation = event.args.sortinformation
        let sortdirection = sortinformation.sortdirection.ascending ? 'ASC' : 'DESC'
        let sortFields = ''
        if (!sortinformation.sortdirection.ascending && !sortinformation.sortdirection.descending) {
            sortdirection = ''
        }
        if (sortdirection) {
            sortFields = `${sortinformation.sortcolumn} ${sortdirection}`
        } else {
            sortFields = ''
        }
        return sortFields
    }

    //onPageSizeChanged(event: any): void {
    //    let args = event.args;
    //    this.source.pagesize = this.myClientsCriteria.PageSize = args.pagesize
    //    this.populateGrid()
    //}
}
